import IconButton from '@mui/material/IconButton';

import { GridCloseIcon } from '@mui/x-data-grid';

export const CloseButton = ({ onClose }: { onClose: (e?: any) => void }) => {
  return (
    <IconButton data-testid="Close" onClick={onClose} size="small" sx={{ marginLeft: 'auto' }}>
      <GridCloseIcon />
    </IconButton>
  );
};
